import { Typography } from "@mui/material";
import React from "react";

export default function Wallet({ data }) {
  return (
    <Typography fontWeight={600} color="text.main" variant="h6">
      {data?.walletType}
    </Typography>
  );
}
